// extracted by mini-css-extract-plugin
export default {"container":"ChangeColumn_container__XKYf0","list":"ChangeColumn_list__MEE2W","btn":"ChangeColumn_btn__N7zhP","icon":"ChangeColumn_icon__pmqPl"};